import {ApolloClient, HttpLink, InMemoryCache} from '@apollo/client';

const baseUrl = process.env.REACT_APP_SETTINGS_URL;
const client = new ApolloClient({
  link: new HttpLink({
    uri: `${baseUrl}/graphql`,
    credentials: 'include',
  }),
  cache: new InMemoryCache(),
});
export default client;
